export default {"src":"/_next/static/media/aion.3dc2334b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};